import { useDeviceType } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';

interface IFormBannerProps {
  form: JSX.Element;
}

export const FormBanner: React.FC<IFormBannerProps> = ({ form }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={clsx(style['wrapper'], style[device])}>{form}</div>
    </div>
  );
};
